import React from 'react'
import ProductList from '../Component/Home/Product/AllProductScreen'

export default function Gallary() {
  return (
   <>
   <ProductList />
   </>
  )
}
